import changeBind from "./changeBind.vue";
import bindMobile from "./bindMobile.vue";
import dayjs from "dayjs";
import { mapState } from "vuex";
import { updateUserInfo } from "@/service/user";
import ShowEncInput from "../Common/ShowEncInput.vue";
export default {
  name: "updatePassword",
  components: {
    // CountryCode,
    bindMobile,
    changeBind
  },
  data() {
    const h = this.$createElement;
    return {
      bindInfo: {
        visible: false
      },
      changeBindInfo: {
        visible: false
      },
      initHasEmail: true,
      initHasMobile: false,
      visible: false,
      loading: false,
      columns: [{
        title: $t("i1y32", "昵称"),
        key: "userName",
        rules: [{
          required: true,
          message: $t("j01h4b6", "昵称不能为空"),
          trigger: "blur,change"
        }, {
          pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,25}$/,
          message: $t("8veaw2o", "仅支持2-25个字符的字母,数字,汉字和部分符号"),
          trigger: "blur,change"
        }]
      }, {
        title: $t("haa72", "手机"),
        disabled: true,
        key: "mobile",
        renderForm: params => {
          if (params.value != "") {
            return h("div", {
              "class": "mobile_bind"
            }, [h(ShowEncInput, {
              "ref": "ShowEncInputMobile",
              "attrs": {
                "disabled": true,
                "params": this.form,
                "encText": params.value,
                "mode": "USER_MOBILE"
              },
              "on": {
                "input": val => {
                  this.$set(this.form, "enc_mobile", val);
                }
              }
            }), h("a", {
              "class": "text-[var(--active-text-color)]",
              "on": {
                "click": () => {
                  this.bindMobile("MOBILE", "CHANGEBIND");
                }
              }
            }, [$t("l6wqyv5", "换绑手机号")])]);
          } else {
            return h("a", {
              "class": "text-[var(--active-text-color)]",
              "on": {
                "click": () => {
                  this.bindMobile("MOBILE", "BIND");
                }
              }
            }, [$t("allzi75", "绑定手机号")]);
          }
        }
      }, {
        title: $t("padf2", "邮箱"),
        key: "email",
        renderForm: params => {
          if (params.value != "") {
            return h("div", {
              "class": "mobile_bind"
            }, [h(ShowEncInput, {
              "ref": "ShowEncInputEmail",
              "attrs": {
                "disabled": true,
                "mode": "USER_EMAIL",
                "encText": params.value,
                "params": this.form
              },
              "on": {
                "input": val => {
                  this.$set(this.form, "enc_email", val);
                }
              }
            }), h("a", {
              "class": "text-[var(--active-text-color)]",
              "on": {
                "click": () => {
                  this.bindMobile("EMAIL", "CHANGEBIND");
                }
              }
            }, [$t("d2jbua4", "换绑邮箱")])]);
          } else {
            return h("a", {
              "class": "text-[var(--active-text-color)]",
              "on": {
                "click": () => {
                  this.bindMobile("EMAIL", "BIND");
                }
              }
            }, [$t("gdxzzg4", "绑定邮箱")]);
          }
        }
      }, {
        title: $t("khba2", "生日"),
        key: "birthday",
        renderForm: {
          type: "DatePicker",
          props: {
            options: {
              disabledDate(date) {
                return date && date.valueOf() > Date.now();
              }
            }
          },
          format(value) {
            return value ? dayjs(value).format("YYYY-MM-DD") : "";
          }
        }
      }],
      form: {}
    };
  },
  methods: {
    close() {
      this.visible = false;
    },
    //更新绑定后手机号/邮箱
    updateMobile(obj) {
      if (obj.email != "") {
        if (!obj.bind) {
          this.$refs.ShowEncInputEmail.show = false;
        }
        this.$delete(this.form, "email");
        this.$set(this.form, "email", obj.email);
        this.$store.commit("setUserInfo", {
          email: obj.email
        });
      }
      if (obj.mobile != "") {
        if (!obj.bind) {
          this.$refs.ShowEncInputMobile.show = false;
        }
        this.$delete(this.form, "mobile");
        this.$set(this.form, "mobile", obj.mobile);
        this.$store.commit("setUserInfo", {
          mobile: obj.mobile
        });
      }
    },
    //绑定手机/邮箱
    bindMobile(accountType, type) {
      if (type === "BIND") {
        this.$refs.bindMobile.init(accountType, this.form.userId);
      } else {
        this.$refs.changeBind.init(accountType, this.form.userId, this.user.userInfo.mobile, this.user.userInfo.email);
      }
    },
    async submit() {
      const {
        birthday,
        userName
      } = this.form;
      const data = {
        birthday,
        userName
      };
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await updateUserInfo(data);
          if (res.data && res.data.result === 0) {
            await this.$store.dispatch("getUserInfo");
            this.$Message.success({
              content: res.data.msg
            });
            this.close();
          }
        }
      });
    },
    init() {
      this.form = this.user.userInfo;
      if (this.form.mobile === "") {
        this.form = {
          mobileAreaCode: "+86",
          ...this.form
        };
      }
      this.visible = true;
    }
  },
  computed: {
    ...mapState(["user"])
  }
};